import axios from 'axios'
import Qs from 'qs'
import utils from './utils'

const serviceStatusUrl = '/api/serviceStatus'
const tokenListUrl = '/api/getTokenList'
const getDepositInfotUrl = '/api/getDepositInfo'
const swapUrl = '/api/startSwap'
const successCode = 200
const internalServerError = 600

function newWebServiceResponse () {
  return {
    res: null,
    errCode: null,
    errMsg: null
  }
}

function parseResponseFromAxiosError (error) {
  let response = newWebServiceResponse()
  if (error.message.includes('timeout')) {
    response.errMsg = error
  } else {
    if (utils.checkIsNotNullObj(error.response)) {
      let res = error.response
      response.errCode = res.status
      response.errMsg = res.data || res.statusText
    } else {
      response.errMsg = error.message
    }
  }
  return response
}

/**
 * format post params when request
 * @param data: params object
 */
function formatPostParams (data) {
  return Qs.stringify(data)
}

export default {
  async isServiceAvailable () {
    let result = newWebServiceResponse()
    try {
      let url = serviceStatusUrl
      return axios.get(url)
        .then(function (response) {
          result.res = response.data.status
          return result
        })
        .catch(function (error) {
          result = parseResponseFromAxiosError(error)
          return result
        })
    } catch (e) {
      result.errMsg = e
      return result
    }
  },
  /**
   * get swap token list
   */
  async getSwapTokenList () {
    let result = newWebServiceResponse()
    try {
      let url = tokenListUrl
      return axios.get(url)
        .then(function (response) {
          result.res = response.data.List
          return result
        })
        .catch(function (error) {
          result = parseResponseFromAxiosError(error)
          return result
        })
    } catch (e) {
      result.errMsg = e
      return result
    }
  },

  /**
   * get deposit info for swap address
   * @param swapType: swap type
   * @param swapAddress: swap address
   */
  async getDepositInfo (swapType, swapAddress, exChangeMemo) {
    let result = newWebServiceResponse()
    try {
      let url = getDepositInfotUrl
      let params = {
        swapType: swapType,
        address: swapAddress,
        memo: exChangeMemo
      }
      let p = formatPostParams(params)
      return axios.post(url, p)
        .then(function (response) {
          console.log('response data is:', response.data)
          let res = response.data
          if (res.hasOwnProperty(utils.statusKey)) {
            let status = res[utils.statusKey]
            if (status === successCode) {
              // success
              if (res.hasOwnProperty(utils.infoKey)) {
                let info = res[utils.infoKey]
                result.res = info
              }
            } else {
              // fail
              result.errCode = status
              result.errMsg = res[utils.msgKey] || ''
            }
          } else {
            result.errCode = internalServerError
            result.errMsg = 'unknown error'
          }
          return result
        })
        .catch(function (error) {
          result = parseResponseFromAxiosError(error)
          return result
        })
    } catch (e) {
      result.errMsg = e
      return result
    }
  },

  /**
   * start swap
   * @param swapType: swap type
   * @param swapAddress: swap address
   */

  async startSwap (swapType, swapAddress) {
    let result = newWebServiceResponse()
    try {
      let url = swapUrl
      let params = {
        swapType: swapType,
        address: swapAddress
      }
      let p = formatPostParams(params)
      return axios.post(url, p)
        .then(function (response) {
          result.res = response.data.List
          return result
        })
        .catch(function (error) {
          result = parseResponseFromAxiosError(error)
          return result
        })
    } catch (e) {
      console.log('error is', e)
      result.errMsg = e
      return result
    }
  }
}
